export default __webpack_public_path__ + "f5626109b006ce855c03da37c0442f9f.png";